module.exports = __webpack_public_path__ + "static/media/action-icon.cd5ea41a.svg";